import { FormikProps } from "formik"
import moment from "moment-timezone"
import useBulkCopyTimeLogsMutation from "@timenotes/shared/src/services/time-logs/queries/use-bulk-copy-time-logs-mutation"
import { Checkbox, DatePicker, Modal, ModalProps, Radio, message } from "antd"
import Flex from "components/shared-components/Flex"
import { useFormik } from "formik"
import { useDefaultDateFormat } from "hooks/settings"
import useApiClient from "hooks/useApiClient"
import { useEffect, useState } from "react"
import { useQueryClient } from "react-query"
import useQueryGenericErrorMessage from "services/utils/hooks/use-query-generic-error-message"

interface FormValues {
  startDate: moment.Moment
  endDate: moment.Moment
  singleDate: moment.Moment
  isSingleDate: boolean
  onlyWorkingDays: boolean
}

interface Props {
  formik: FormikProps<FormValues>
}

export function getBulkFormFieldInitialValues() {
  return {
    startDate: moment(),
    endDate: moment(),
    singleDate: moment(),
    isSingleDate: true,
    onlyWorkingDays: false,
    targets: [],
  }
}

export function BulkDateFormFields(props: Props) {
  const {
    formik
  } = props

  const { defaultDateFormat } = useDefaultDateFormat()

  return (
    <>
      <Radio
        checked={formik.values.isSingleDate}
        onChange={(checked) => {
          formik.setFieldValue('isSingleDate', checked)
        }}
      >
        Single day
      </Radio>
      <DatePicker
        allowClear={false}
        value={formik.values.singleDate}
        onChange={(value) => {
          formik.setFieldValue('singleDate', value)
        }}
        format={defaultDateFormat}
        disabled={!formik.values.isSingleDate}
      />
      <br />
      <br />

      <Radio
        checked={!formik.values.isSingleDate}
        onChange={(checked) => {
          formik.setFieldValue('isSingleDate', !checked)
        }}
      >
        Multiple days from
      </Radio>

      <DatePicker
        allowClear={false}
        value={formik.values.startDate}
        onChange={(val) => {
          formik.setFieldValue('startDate', val)
        }}
        format={defaultDateFormat}
        disabled={formik.values.isSingleDate}
      />
      to
      <DatePicker
        allowClear={false}
        value={formik.values.endDate}
        onChange={(val) => {
          formik.setFieldValue('endDate', val)
        }}
        format={defaultDateFormat}
        disabled={formik.values.isSingleDate}
      />

      <div
        style={{
          height: '20px',
          marginTop: '10px',
        }}
      >
        {!formik.values.isSingleDate && (
          <Flex
            justifyContent="start"
          >
            <Checkbox
              style={{ marginRight: '30px' }}
              checked={formik.values.onlyWorkingDays}
              onChange={(e) => {
                formik.setFieldValue('onlyWorkingDays', e.target.checked)
              }}
              disabled={formik.values.isSingleDate}
            >
              Log time only into the workspace work week days in this period.
            </Checkbox>
          </Flex>
        )}
      </div>
    </>

  )
}